import Vue from 'vue'
import VueI18n from 'vue-i18n'
import langMessages from '@/lang'
import axios from 'axios'
import { language_t } from '@/store/modules/pref'
import moment from 'moment'
import VeeValidate from 'vee-validate'
// ======================================================
// i18n
// ======================================================

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'en', // set locale
  fallbackLocale: 'en',
  messages: langMessages // set locale messages
})

// export function autoSetLang<T extends {$validator: VeeValidate.Validator}> (vm: T, lang: language_t) {}


export function getLanguageFromBrowser (): language_t {
  const [x] = navigator.language.split('-')
  if (isSupportedLanguage(x)) { return x as language_t }
  console.warn('[Notice] Language of browser is not supported by SmartCOntroller, use English (en) as fallback.')
  return 'en'
}

export function isSupportedLanguage (x: string): boolean {
  return x === 'en' || x === 'zh' || x === 'ja'
}

export function setLang<T extends {$validator: VeeValidate.Validator}> (vm: T, lang: language_t) {
  if (lang === 'auto') {
    lang = getLanguageFromBrowser()
  }
  console.log('lang===', lang)
  i18n.locale = lang
  moment.locale(lang)
  vm.$validator.localize(lang)
  axios.defaults.headers.common['Accept-Language'] = lang
  const html = document.querySelector('html')
  if (!html) { return '' }
  html.setAttribute('lang', lang)
  return lang
}

export default i18n
